export default __webpack_public_path__ + "static/media/ic_share.90bac281.svg";